import React, { useState } from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Customized,
} from 'recharts';
import './index.scss';

const PSValueChart = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(data.length - 1);
  const [showInfo, setShowInfo] = useState(false);

  const showInfoTooltip = () => {
    setShowInfo(!showInfo);
    console.log(showInfo);
  };

  return (
    <div className="value-chart__container">
      <div className="value-chart__container--title">
        <h3>Valor cuota</h3>
        <p>
          Precio actual de cada unidad de tu <span>Fondo Balanceado.</span>
        </p>
      </div>

      <div className="value-chart__container--graph">
        <ResponsiveContainer>
          <AreaChart
            data={data}
            margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
            onMouseMove={(state) => {
              if (state && state.activeTooltipIndex !== undefined) {
                setActiveIndex(state.activeTooltipIndex);
              }
            }}
            onMouseLeave={() => setActiveIndex(data.length - 1)}
          >
            <defs>
              <linearGradient id="colorArea" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#581BC7" stopOpacity={0.6} />
                <stop offset="100%" stopColor="#2B0D61" stopOpacity={0} />
              </linearGradient>

              <linearGradient id="barGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#F3EFFA" />
                <stop offset="100%" stopColor="#2B0D61" />
              </linearGradient>
            </defs>

            <CartesianGrid vertical={false} stroke="#E3E3E8" />

            <XAxis
              dataKey="mes"
              tick={{ fill: '#2B0D61' }}
              axisLine={{ stroke: '#2B0D61', strokeWidth: 1 }}
              tickLine={false}
              padding={{ left: 20, right: 20 }}
              interval="preserveStartEnd"
            />
            <YAxis
              hide
              domain={[
                (dataMin) => dataMin * 0.995, // 👈 baja un poco el mínimo
                (dataMax) => dataMax * 1.005, // 👈 sube un poco el máximo
              ]}
            />

            {/* Área principal */}
            <Area
              type="linear"
              dataKey="valorCuota"
              stroke="#2B0D61"
              fill="url(#colorArea)"
              strokeWidth={3}
              isAnimationActive={false}
            />

            {/* Barra vertical + Tooltip */}
            <Customized
              component={(props) => {
                const { formattedGraphicalItems, height } = props;
                if (!formattedGraphicalItems || formattedGraphicalItems.length === 0) return null;

                const { points } = formattedGraphicalItems[0].props;
                if (!points || !points[activeIndex]) return null;

                const { x, y, payload } = points[activeIndex];
                const tooltipWidth = 100;
                const tooltipHeight = 55;

                // Posición del tooltip justo arriba del punto
                const tooltipY = y - tooltipHeight - 20;

                return (
                  <>
                    {/* Barra vertical */}
                    <rect
                      x={x - 12.5}
                      y={y}
                      width={25}
                      height={Math.max(0, height - y - 50)}
                      fill="url(#barGradient)"
                      opacity={1}
                      pointerEvents="none"
                    />

                    {/* Dot fijo */}
                    <circle
                      cx={x}
                      cy={y}
                      r={12}
                      fill="#F3EFFA"
                      stroke="#2B0D61"
                      strokeWidth={3}
                      pointerEvents="none"
                    />

                    {/* Tooltip */}
                    <foreignObject
                      x={x - tooltipWidth / 2}
                      y={tooltipY}
                      width={tooltipWidth}
                      height={tooltipHeight + 10}
                      style={{ overflow: 'visible', pointerEvents: 'none' }}
                    >
                      <div
                        style={{
                          position: 'relative',
                          background: '#F8F7FF',
                          border: '1px solid #E0E0E0',
                          padding: '8px 12px',
                          borderRadius: '8px',
                          boxShadow: '0px 3px 8px rgba(0,0,0,0.15)',
                          textAlign: 'center',
                          fontSize: 10,
                          color: '#2B0D61',
                        }}
                      >
                        <div style={{ fontWeight: 'bold', fontSize: 12 }}>
                          S/ {payload.valorCuota}
                        </div>
                        <div style={{ color: '#555' }}>Valor cuota del {payload.fecha}</div>

                        <div
                          style={{
                            position: 'absolute',
                            bottom: -6,
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '6px solid transparent',
                            borderRight: '6px solid transparent',
                            borderTop: '6px solid white',
                            filter: 'drop-shadow(0px 1px 2px rgba(0,0,0,0.1))',
                          }}
                        />
                      </div>
                    </foreignObject>
                  </>
                );
              }}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="value-chart__container--info">
        <p>
          ¿Quiere saber más? Conoce qué es el valor cuota y cómo se calcula su fondo a partir de
          este valor, <span onClick={() => showInfoTooltip()}>desde aquí.</span>
        </p>
      </div>

      {showInfo && (
        <div className="popup-overlay" onClick={() => showInfoTooltip()}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <p>
              El valor cuota es el precio de cada cuota de participación en un fondo de inversión o
              en una estructura de inversión colectiva. Se calcula dividiendo el patrimonio total
              del fondo entre el número total de cuotas en circulación. Este valor se calcula
              diariamente y es el reflejo de todas las inversiones que ha hecho el fondo, reflejando
              así las ganancias o pérdidas.
            </p>
            <button type="button" onClick={() => showInfoTooltip()}>
              Cerrar
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PSValueChart;
